// ========== plugin import ========= //
import React, {useEffect, useRef} from 'react'
import { useLocation } from 'react-router-dom';

// ======== component import ========== //
import { 
    PlSection_1,
    PlHowItsWorks,
    PlDeveloperGuide,
    PlPricing,
    PlIntegration
} from './component';
const Platform = () => {
    /*const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - 100,
                    behavior: 'smooth'
                });
            }
        }
        else{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);*/
    const location = useLocation();

    useEffect(() => {
        const scrollToHash = () => {
          if (location.hash) {
            const id = location.hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
              const elementTop = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementTop - 100,
                behavior: 'smooth',
              });
            }
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        };
    
        // Delay to allow DOM rendering
        setTimeout(scrollToHash, 100);
      }, [location.pathname, location.hash]);

    return (
        <>
            <section className="hero-area hero-area-background">
                <PlSection_1 />
            </section>
            <section className='mt-20'>
                <div className="container">
                    <div id="how-its-works">
                        <PlHowItsWorks />
                    </div>
                    <div id="developer-guide">
                        <PlDeveloperGuide />
                    </div>
                    <div id="pricing">
                        <PlPricing />
                    </div>
                    <div id="integration">
                        <PlIntegration />
                    </div>
                </div>
            </section>
        </>
    )
}

export {Platform}